export const ROBOT_VEHICLE_TYPE = "RBT";
